"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utility_1 = require("../utility");
var rule = {
    nativeMultiSendRule: {
        type: "transfer",
        attributes: [["recipient"], ["amount"]],
    },
    nativeSendRule: {
        type: "transfer",
        attributes: [["recipient"], ["sender"], ["amount"]],
    },
    delegateRule: {
        type: "delegate",
        attributes: [["validator"], ["amount"]],
    },
    unDelegateRule: {
        type: "unbond",
        attributes: [["validator"], ["amount"], ["completion_time"]],
    },
    cw20SendRule: {
        type: "from_contract",
        attributes: [
            ["contract_address"],
            ["action", "send"],
            ["from"],
            ["to"],
            ["amount"],
        ],
    },
    cw20TransferRule: {
        type: "from_contract",
        attributes: [
            ["contract_address"],
            ["action", "transfer"],
            ["from"],
            ["to"],
            ["amount"],
        ],
    },
    cw20MintRule: {
        type: "from_contract",
        attributes: [["contract_address"], ["action", "mint"], ["to"], ["amount"]],
    },
    cw20TransferFromRule: {
        type: "from_contract",
        attributes: [
            ["contract_address"],
            ["action", "transfer_from"],
            ["from"],
            ["to"],
            ["by"],
            ["amount"],
        ],
    },
    cw20BurnRule: {
        type: "from_contract",
        attributes: [
            ["contract_address"],
            ["action", "burn"],
            ["from"],
            ["amount"],
        ],
    },
};
var create = function () {
    var nativeSendRule = {
        rule: rule.nativeSendRule,
        transform: function (_, matched) { return ({
            type: "send",
            amount: matched[2].value,
            sender: matched[1].value,
            recipient: matched[0].value,
        }); },
    };
    var nativeMultiSendRule = {
        rule: rule.nativeMultiSendRule,
        transform: function (_, matched) { return ({
            type: "multiSend",
            amount: matched[1].value,
            recipient: matched[0].value,
        }); },
    };
    var delegateRule = {
        rule: rule.delegateRule,
        transform: function (_, matched) { return ({
            type: "delegate",
            amount: utility_1.attachDenom(matched[1].value),
            recipient: matched[0].value,
        }); },
    };
    var unDelegateRule = {
        rule: rule.unDelegateRule,
        transform: function (_, matched) { return ({
            type: "unDelegate",
            amount: utility_1.attachDenom(matched[1].value),
            sender: matched[0].value,
            withdraw_date: matched[2].value,
        }); },
    };
    var cw20SendRule = {
        rule: rule.cw20SendRule,
        transform: function (_, matched) { return ({
            type: "cw20Send",
            amount: "" + matched[4].value + matched[0].value,
            sender: matched[2].value,
            recipient: matched[3].value,
        }); },
    };
    var cw20TransferRule = {
        rule: rule.cw20TransferRule,
        transform: function (_, matched) { return ({
            type: "cw20Transfer",
            amount: "" + matched[4].value + matched[0].value,
            sender: matched[2].value,
            recipient: matched[3].value,
        }); },
    };
    var cw20MintRule = {
        rule: rule.cw20MintRule,
        transform: function (_, matched) { return ({
            type: "cw20Mint",
            amount: "" + matched[3].value + matched[0].value,
            recipient: matched[2].value,
        }); },
    };
    var cw20TransferFromRule = {
        rule: rule.cw20TransferFromRule,
        transform: function (_, matched) { return ({
            type: "cw20TransferFrom",
            amount: "" + matched[5].value + matched[0].value,
            sender: matched[2].value,
            recipient: matched[3].value,
        }); },
    };
    var cw20BurnRule = {
        rule: rule.cw20BurnRule,
        transform: function (_, matched) { return ({
            type: "cw20Burn",
            amount: "" + matched[3].value + matched[0].value,
            sender: matched[2].value,
        }); },
    };
    return [
        nativeSendRule,
        nativeMultiSendRule,
        delegateRule,
        unDelegateRule,
        cw20SendRule,
        cw20TransferRule,
        cw20MintRule,
        cw20TransferFromRule,
        cw20BurnRule,
    ];
};
exports.default = create;
//# sourceMappingURL=index.js.map